function withDefault(param, defaultValue) {
  let includeNull = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  const decodeWithDefault = function () {
    const decodedValue = param.decode(...arguments);
    if (decodedValue === void 0) {
      return defaultValue;
    }
    if (includeNull) {
      if (decodedValue === null) {
        return defaultValue;
      } else {
        return decodedValue;
      }
    }
    return decodedValue;
  };
  return {
    ...param,
    default: defaultValue,
    decode: decodeWithDefault
  };
}
var withDefault_default = withDefault;
export { withDefault_default as default, withDefault };
//# sourceMappingURL=withDefault.js.map